<template>
	<header class="fixed top-0 w-full z-40">
		<div class="container mx-auto grid grid-flow-col pb-6">
			<router-link id="Navbar--Logo"
				to="/"
				class="relative w-max pl-px ml-5 sm:ml-0">

				<img class="relative w-14 mx-1.5 mt-2.5 shadow-md rounded-full"
					src="/img/logo.webp"
					width="56px"
					height="56px"
					alt="Home" />
			</router-link>

			<nav id="App--Navigation"
				class="grid grid-flow-col w-max space-x-10 items-center text-white uppercase font-bold justify-self-end pt-3 z-20 mr-6 sm:mr-0">
				<slot></slot>
			</nav>
		</div>
	</header>
</template>

<script>
import { NavbarTimeline } from '@/animations/Navbar.timeline'

export default {
	name: 'Navbar',

	computed: {
		metadata() {
			return this.$route.meta
		},

		menus() {
			if (!this.$route || !this.$route.meta || !this.$route.meta.menus)
				return []

			return this.$route.meta.menus
		},
	},

	mounted() {
		NavbarTimeline.start()
	},
}
</script>